<template>
  <div v-if="item.trackExpirationDate && expiry" style="height: 32px" class="align-content-center">
    <img v-if="showIcon" src="/mat-sig/expiry.svg" alt="Expiration" class="align-bottom mx-1" style="height: 1.4em;" />
    {{ $d(new Date(expiry), 'dateonly') }}
  </div>
  <div v-else style="height: 32px">&nbsp;</div>
</template>

<script setup lang="ts">
import Item from "@/models/frontend/Item";

defineProps({
  item: { type: Object as () => Item, required: true },
  expiry: { type: String, required: false },
  showIcon: { type: Boolean, default: false }
});
</script>
